<script setup lang="ts">
import { ref, computed, onMounted } from "vue"
import { useRoute } from 'vue-router'
import ModalDownload from '~/components/ui/modal-download/ModalDownload.vue'
import ModalInfoDownload from '~/components/ui/modal-download/ModalInfoDownload.vue'
import PopupCommon from '~/components/ui/popup/PopupCommon.vue'
import { useGetCookie } from '~/composables/common/useCustomCookie'
import { publicDomain } from '~/helper'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import { debounceHeapTracking } from '~/mixins/heap'
import useFormValidation from '~/utils/validators'
import { useCurrenciesStore } from '~/store/pinia/currencies'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

const route = useRoute()
const is_verified = useGetCookie('is_verified').value //getCookie('is_verified=')
const { isDesktopOrTablet } = useDevice()
const domain = publicDomain()
const { resetErrors } = useFormValidation()
const currenciesStore = useCurrenciesStore()
const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
const currencySelected = computed(() => currenciesStore.currencySelected /*store.state.currenciesStore.currencySelected*/)
const downloadTitle = computed(() => {
  if (!is_verified && domain === 'traveller') {
    if (downloadedStatus.value) return "We've Sent It to Your Email"
    return ''
  }
  return 'Download'
})
const downloadModalWidth = computed(() => {
  if (!is_verified && domain === 'traveller') {
    if (downloadedStatus.value) return '400'
    return '572'
  }
  return '400'
})
const pageType = computed(() => {
  if (route.name === 'trip-plan-bookable') return 'bookable'
  if (route.name === 'trip-preview') return 'preview'
  return 'gallery'
})

const downloadedStatus = ref(false)
const modalDownloadActive = ref(false)

function closeDownloadModal(value: boolean) {
  modalDownloadActive.value = value
  downloadedStatus.value = value
  resetErrors()
}
function changeStatusDownload() {
  downloadedStatus.value = !downloadedStatus.value
  //   downloadInfo.value = useGetCookie('download_info').value
}
function toggleModalDownload(source = 'trip-plan-actions-bar') {
  modalDownloadActive.value = !modalDownloadActive.value
  if (modalDownloadActive.value === false) {
    debounceHeapTracking('View Download Trip Plan Popup', {
      source_widget: source,
      is_logged_in_user: !!is_verified,
    })
    debounceAmplitudeScriptTracking('View Download Trip Plan Popup', {
      source_widget: source,
      is_logged_in_user: !!is_verified,
    })
  }
}
defineExpose({
  toggleModalDownload,
  closeDownloadModal,
})
onMounted(() => {
  if (route.query.download && route.query.download === '1') {
    modalDownloadActive.value = true
  }
})
</script>

<template>
  <PopupCommon :modalTitle="downloadTitle" :modalActive="modalDownloadActive" @update:close="closeDownloadModal" :maxWidth="downloadModalWidth" overflowBody>
    <template #content>
      <ModalInfoDownload
        v-if="!is_verified && domain === 'traveller'"
        :downloadedStatus="!downloadedStatus"
        :id="dataTrip.id"
        :currency="currencySelected.code"
        :pageType="pageType"
        @change-status-download="changeStatusDownload"
        v-model:modalActive="modalDownloadActive"
        :class="downloadTitle ? '' : isDesktopOrTablet ? 'px-30 pb-60' : 'pa-30 pt-0'"
      />

      <ModalDownload v-else :id="dataTrip.id" :currency="currencySelected.code" :pageType="pageType" v-model:modalActive="modalDownloadActive" />
    </template>
  </PopupCommon>
</template>

<style lang="scss" scoped></style>
